export const toConfiormSupportPayload = values => ({
  truckId: values.truckId,
  supportList: values.supportList
})